<template>
  <v-container class="follow" fluid>
    <v-row>
      <v-col>
        <p class="text-center">
          Follow
          <a
            href="https://www.instagram.com/chef_naturelle/"
            target="_blank"
          >@chef_naturelle</a>
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  VCol,
  VContainer,
  VRow,
} from 'vuetify/lib'

export default {
  components: {
    VCol,
    VContainer,
    VRow,
  },
}
</script>

<style lang="scss" scoped>
.follow {
  p {
    font-size: 20px;
  }
}
</style>
